import React, {ReactNode} from "react";
import {useAuth} from "../context/AuthContext";
import {Navigate} from "react-router-dom";
import {LoadingPageView} from "../../../common/components/LoadingPageView";


interface PublicRouteProps {
    children: ReactNode;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {

    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return (
            <LoadingPageView/>
        );
    }

    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};